// App.js - WEB
import React, {PureComponent} from 'react';
import {
    I18nManager, Platform, Text, View,
} from 'react-native';

import {Provider} from 'react-redux';
import store from './redux/store';
//import {askForPermissioToReceiveNotifications} from "./firebase/web/push-notification";
// import firebase from 'react-native-firebase';
//import firebase from "./firebase/web/firebase";
import Router from './router/Router';
import i18n from './I18n/i18n';

import {AsyngStorageClass} from './tools/AsyngStorageClass';
// import {Tools} from "./tools/Tools";
import {changeAppLang} from './tools/Tools1';
import _G_ from './tools/constant/_G_';
//import {isBrowser, isMobile} from "react-device-detect";

//import {HashRouter} from "react-router-dom";

// import {I18nManager as I18nManagerWeb } from "react-native-web";
import 'react-native-gesture-handler';
export default class App extends PureComponent {
    constructor(props) {
        super(props);
        global._SpeechRecognition = null;
        global._recognition = null;
        if (Platform.OS === 'web') {

            var voices = [];

            var speechSynthesis = window.speechSynthesis || window.webkitspeechSynthesis;
            if (speechSynthesis) {
                /*     speechSynthesis.onvoiceschanged = function () {
                         voices = speechSynthesis.getVoices();
                         console.log("voices@", voices);
                     };*/
                /*      let msg = new SpeechSynthesisUtterance();
                      msg.voice = voices[0];
                      //msg.lang ='ar-SA';
                      msg.lang ='en-US';
                      // msg.text = "احمد خلیل";
                      msg.text = "Your problem seems to be not treating the Web Speech API asynchronously";
                      speechSynthesis.speak(msg);*/
            }


            global._SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
            if (global._SpeechRecognition) {
                global._recognition = new global._SpeechRecognition();

                global._recognition.continuous = true;
                global._recognition.lang = 'fa-IR';
                global._recognition.interimResults = true;


            }
        }
        // if('caches' in window){
        //     caches.keys().then((names) => {
        //         // Delete all the cache files
        //         names.forEach(name => {
        //             caches.delete(name);
        //         })
        //     });
        //
        //     // Makes sure the page reloads. Changes are only visible after you refresh.
        //     window.location.reload(true);
        // }
        //alert("isBrowser" + isBrowser + " : " + "_______isMobile" + " : " + isMobile)
        // global._isMobile = isMobile;
        this.registerPushListener = pushNotification =>
            navigator.serviceWorker.addEventListener('message', ({data}) => {
                    const notificationTitle = data['firebase-messaging-msg-data'].notification.title;
                    const notificationOptions = {
                        body: data['firebase-messaging-msg-data'].notification.body,
                        icon: data['firebase-messaging-msg-data'].notification.icon,
                        logo: data['firebase-messaging-msg-data'].notification.icon,
                    };

                    // runtime.register().then(registration => {
                    //     registration.showNotification(notificationTitle, notificationOptions);
                    //
                    // })
                    if (Notification.permission === 'granted') {
                        navigator.serviceWorker.ready.then(function (registration) {

                            //  global._refreshSplashSatia = true;
                            registration.showNotification(notificationTitle, notificationOptions,
                                //     {
                                //     body: 'Buzz! Buzz!',
                                //     icon: PathFile.image.logo,
                                //     vibrate: [200, 100, 200, 100, 200, 100, 200],
                                //     tag: 'vibration-sample'
                                // }
                            );
                        });
                        // navigator.serviceWorker.getRegistration().then(reg => {
                        //     reg.showNotification(notificationTitle, notificationOptions);
                        // });
                    }

                    /*     this.registration.showNotification('Vibration Sample', {
                             body: 'Buzz! Buzz!',
                             icon: '../images/touch/chrome-touch-icon-192x192.png',
                             vibrate: [200, 100, 200, 100, 200, 100, 200],
                             tag: 'vibration-sample'
                         });*/
                    /* navigator.serviceWorker.ready.then(function(registration) {
                         alert("fghfg")
                         registration.showNotification('Vibration Sample', {
                             body: 'Buzz! Buzz!',
                             icon: '../images/touch/chrome-touch-icon-192x192.png',
                             vibrate: [200, 100, 200, 100, 200, 100, 200],
                             tag: 'vibration-sample'
                         });
                     });*/
                    // console.log(data )
                    // message.info(data["firebase-messaging-msg-data"]?.notification?.title + ':' + data["firebase-messaging-msg-data"]?.notification?.notification?.body)

                    /*  pushNotification(
                          data.data
                              ? data.data.message
                              : data["firebase-messaging-msg-data"].notification
                      )*/
                },
            );
    }

    async componentWillMount() {
       // console.log('componentDidMount@@@111',I18nManager);

        //  this.sendPushNotification();
        let l = await AsyngStorageClass.getLang();
        //document.documentElement.setAttribute('dir', l == 'fa' ? 'rtl' : 'ltr');

        i18n.locale = (l);

        //console.log('@@##1', l, i18n.locale);
        //_G.locale = 'fa';

        if (l == 'en' || l == null) {
            i18n.locale = 'fa';
            //Tools.changeAppLang('fa')
            changeAppLang('fa');
        }
       await I18nManager.forceRTL(l == 'fa');
        await I18nManager.allowRTL(l == 'fa');
        // I18nManager.forceRTL(true);
        // I18nManagerWeb.forceRTL(true);
          // await I18nManager.swapLeftAndRightInRTL(false);
        // document.getElementsByTagName('html').setAttribute("dir", "revert");
         //document.documentElement.setAttribute('dir', "rtl");
        // document.documentElement.outerHTML.setAttribute("lang", "fa");

        _G_.RTL = (l == 'fa');
        //console.log('@@##1_G1', _G_.RTL,I18nManager.getConstants().isRTL,I18nManager.isRTL);

        /*        window.addEventListener("beforeunload", function(event) { alert("xkvjxhv")});
                window.addEventListener("beforeinstallprompt", ev => {
                    // Stop Chrome from asking _now_
                    ev.preventDefault();
        alert("vbnvbdfdf")
                    // Create your custom "add to home screen" button here if needed.
                    // Keep in mind that this event may be called multiple times,
                    // so avoid creating multiple buttons!
                 //   myCustomButton.onclick = () => ev.prompt();
                });*/
        //  window.addEventListener("unload", function(event) { alert("vbnbv") });

        /*    if (window.performance) {
                if (performance.navigation.type == 1) {
                    alert( "This page is reloaded" );
                } else {
                    alert( "This page is not reloaded");
                }
            }*/
        if ('Notification' in window) {
            // this.getToken();
            // this.askForPermissioToReceiveNotifications();

            /*     try {

                     const messaging = firebase.messaging();
                     await messaging.onMessage(notification => {
                         message.info(notification?.data?.title + ':' + notification?.data?.body)
                     });

                     const registration = await navigator.serviceWorker
                         .register('firebase-message-sw.js', {scope: "/", updateViaCache: 'none'})
                         .then((registration) => {
                             return registration;
                         }).catch(e => {
                         });
                     await Notification.requestPermission().then((callBack) => {
                     }).catch(e => {
                     });
                     const token = await messaging.getToken({
                         vapidKey: 'BML-',
                         serviceWorkerRegistration: registration
                     });
                     await //send token


                     return token;

                 } catch (error) {
                     console.error(error);
                 }*/

            /*     if (!localStorage.getItem('notification-token')) {
                     askForPermissioToReceiveNotifications();
                 }*/


        } else {
            console.log(' not supported');
        }


        // this.initializeFirebase()
        // this.askForPermissioToReceiveNotifications()
    }

    /*    initializeFirebase = () => {
            firebase.initializeApp({

                apiKey: "AIzaSyDqX1labatJBlnnHNgmO0R3kngZOsXTTwU",
                authDomain: "satiaapp.firebaseapp.com",
                databaseURL: "https://satiaapp.firebaseio.com",
                projectId: "satiaapp",
                storageBucket: "satiaapp.appspot.com",
                messagingSenderId: "1026712654485",
                appId: "1:1026712654485:web:160c851231b8b6e1d1c19c",
                measurementId: "G-ES9XHPDEMC"
            });
            //const messaging = firebase.messaging();
        }*/
    askForPermissioToReceiveNotifications = async (registration) => {

        try {
            const messaging = firebase.messaging();
            await messaging.requestPermission();
            const token = await messaging.getToken();
            await AsyngStorageClass.setAsyng('fcmToken', token);

            return token;
        } catch (error) {
            //  alert(error)

            console.error(error);
        }

        /*      try {

                  const messaging = firebase.messaging();
                  await messaging.onMessage(notification => {
                      message.info(notification?.data?.title + ':' + notification?.data?.body)
                  });

                  const registration = await navigator.serviceWorker
                      .register('firebase-message-sw.js', {scope: "/", updateViaCache: 'none'})
                      .then((registration) => {
                          return registration;
                      }).catch(e => {
                      });
                  await Notification.requestPermission().then((callBack) => {
                  }).catch(e => {
                  });
                  const token = await messaging.getToken({
                      vapidKey: 'BML-',
                      serviceWorkerRegistration: registration
                  });
                  await //send token


                  await AsyncStorage.setItem('fcmToken', token);

                  return token;

              } catch (error) {
                  console.error(error);
              }*/
    };

    //3
    getToken = async () => {
        try {


            let fcmToken = await AsyncStorage.getItem('fcmToken');
            global.token_fb = fcmToken;
            const messaging = firebase.messaging();

            console.log('fcmToken', fcmToken);
            if (!fcmToken) {

                fcmToken = await messaging.getToken();

                if (fcmToken) {
                    //  ConstantsClass.token_fb = fcmToken;
                    // user has a device token
                    await AsyncStorage.setItem('fcmToken', fcmToken);
                }
            }


            await messaging.onMessage(notification => {
                message.info(notification?.data?.title + ':' + notification?.data?.body);
            });
            this.registerPushListener('');
//         const message = new firebase.messaging.RemoteMessage()
//             .setMessageId('110000')
//             .setTo('99933604098@gcm.googleapis.com')
//             .setData({
//                 key1: 'test',
//                 key2: 'value2',
//             });
// // Send the message
//         firebase.messaging().sendMessage(message);
        } catch (error) {

            console.error(error);
        }
    };
    sendPushNotification = async () => {
        const FIREBASE_API_KEY = 'AAAA7wzX0pU:APA91bHdOEeVHMseJY61qh2Rrb-JOLg2L7X0qnTX1b-SV_AT-amipg0MovNVINHuDqA0Qfau5K2y0u39ynkgkaackXH8jaeTaWAL-IS2ILW2k-MbDQOXwjiOIZ9I6bs3mBm9B-v4tphd';
        const message = {
            //  registration_ids: ["f-0287B5ltG1SYnWGEo3Dy:APA91bG0nbEVs_wROalwId8jiHblbUBXbqmuKILSPSvsBFkMjc-wLGQ3OqAclxrwiHCtVx6l724msmrJX4APCFkbYpPq2otK-sFz4o7z914sLd402sEgMUdttfzQgbJMB2kSsKOjL_PO"],
            registration_ids: ['ejuo2OsvimvVGIPQchWQpT:APA91bGHmznFkLMufU1FDkTLt6I4PpyYPXBAdtTeVe-2ZE0APNorYj4zkpwsASbrzJ_aAKXuUjlWjINK3i-FPTfl_qNt-PbBwxa38UyZETiN1mecDjalkbzeLTSycfJFJkIodgbE5eRS'],
            notification: {
                title: 'india vs south africa test',
                body: 'IND chose to bat',
                'vibrate': 1,
                'sound': 1,
                //"show_in_foreground": true,
                'priority': 'high',
                'content_available': true,
            },
            data: {
                menu: [
                    {
                        name: 'درخواست ها و شکایات جدید',
                        type: 1,
                        image: 'http://185.113.56.50/layouts/v7/lib/todc/img/complaint.png',
                        count: 100,
                    },
                    {
                        name: 'در دست بررسی و اقدام',
                        type: 2,
                        image: 'http://185.113.56.50/layouts/v7/lib/todc/img/darkhast.png',
                        count: 1,
                    },
                    {
                        name: 'ثبت پیام جدید',
                        type: 3,
                        image: 'http://185.113.56.50/layouts/v7/lib/todc/img/Sabt-payam.png',
                    },
                    {name: 'پیام های من', type: 4, image: 'http://185.113.56.50/layouts/v7/lib/todc/img/mail.png'},
                ],
                item: {
                    address: '',
                    assigned: 'علی علوی تبار',
                    assigned2: null,
                    color: '#ff0000',
                    createdtime: '1399-06-01 17:20:44',
                    date_end: '1399-06-04 04:30:00',
                    date_start: '1399-06-01 04:30:00',
                    files: [],
                    groupassigned: 'گروه سازمان مدیریت پسماند',
                    id: '9x210609',
                    importance: 'معمولي',
                    lastWork: [],
                    latitude: '34.0956347',
                    longitude: '49.6913344',
                    messageid: '17x210608',
                    messageno: '99060127',
                    source: 'نرم افزار وب ساینا',
                    status: 'ثبت شد',
                    subject: 'پرینت و ابلاغ حکم کار',
                    taskstatus: 'Not Started',
                    tasktype: 'برنامه 137',
                    title: 'رفع آبگرفتکی پرشدن چاه جذبی و ایجاد آبگرفتگی',
                },
                typeOperation: '1',
                title: 'india vs south africa test',
                body: 'IND chose to bat',
                score: 50,
                wicket: 1,
            },
        };

        let headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': 'key=' + FIREBASE_API_KEY,
        });

        let response = await fetch('https://fcm.googleapis.com/fcm/send', {
            method: 'POST',
            headers,
            body: JSON.stringify(message),
        });

        response = await response.json();


        /*    const payloadWeb = {
                title: "erwerw",
                body: "sdfsdf",
                data: {
                    title: "ghjgh",
                    body: "gjfghsA"
                },
                tokens: ["AAAA7wzX0pU:APA91bHdOEeVHMseJY61qh2Rrb-JOLg2L7X0qnTX1b-SV_AT-amipg0MovNVINHuDqA0Qfau5K2y0u39ynkgkaackXH8jaeTaWAL-IS2ILW2k-MbDQOXwjiOIZ9I6bs3mBm9B-v4tphd"],
            }

            const responseWeb = await firebase.messaging().sendMulticast(payloadWeb);
            console.log(responseWeb.successCount + ' notifications has been sent to Web successfully');

    */
    };

    render() {
        return (
            <Provider store={store}>

                {/*<HashRouter>*/}
                <Router/>

                {/*</HashRouter>*/}
            </Provider>
        );
    }


    /*    render() {
            return (
                <View>
                    <Text>
                        aaaaaa
                    </Text>
                </View>
            );
        }*/

}
